import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import RichTextEditor from "react-rte";
import { styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../../recoil-store/recoil-state';

const Input = styled('input')({
    display: 'none',
});

const StepSix = (props) => {
    const { t } = useTranslation();
    const setAlert = useSetRecoilState(alertState);
    const [fileName, setFileName] = useState(props.publishDetail.publish_detail["images"]);
    const [editorState, setEditorState] = useState(props.publishDetail.publish_detail["guide"] ?
        RichTextEditor.createValueFromString(props.publishDetail.publish_detail["guide"].toString("html"), "html") :
        RichTextEditor.createEmptyValue())
    const handleEdit = value => {
        setEditorState(value)
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                guide: editorState
            }
        }))
    }

    useEffect(() => {
        props.setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                images: fileName,

            }
        }))
    }, [fileName])

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file)
            fileReader.onload = () => {
                resolve(fileReader.result);
            }
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    const handleFileRead = async (event) => {
        
        let files = [...fileName];
        for (const file of event.target.files) {
            const base64 = await convertBase64(file)
            files.push(base64);
        }

        if (files.length < 8) {
            // setFileName(oldArr => [...oldArr, base64])
            setFileName(files)
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t('CONTENT.PUBLISH.ERROR-IMAGE'), severity: 'error' }))
        }
    }

    useEffect(() => {
        let valHtml = editorState.toString('html').replace(/(<([^>]+)>)/gi, "").trim()
        if (valHtml.length > 0) { // && fileName.length > 0
            props.setIsRequired(false)
        } else {
            props.setIsRequired(true)
        }
    }, [fileName, editorState])

    return (
        <DialogContent style={{ padding: "20px 0 0 0" }}>
            <div style={{ textAlign: "left" }}>
                <Grid container>
                    <Grid item xs={3}>
                        <span style={{
                            fontSize: 12,
                            color: "#8F94A6",
                            fontWeight: 700
                        }}>{t('CONTENT.PUBLISH.GUIDE')}</span>
                    </Grid>
                    <Grid item xs={12}>
                        <RichTextEditor
                            editorClassName="publish-editor"
                            value={editorState}
                            onChange={value => handleEdit(value)}
                        />
                    </Grid>
                    {
                        props.publishDetail.publish_detail.type === 'bot' &&
                        <>
                            <Grid item xs={12}
                                style={{ marginTop: "1rem" }}>
                                <div id="upload-box">
                                    <label htmlFor="contained-button-file">
                                        <Input accept="image/*" id="contained-button-file" multiple type="file"
                                            onChange={e => handleFileRead(e)} />
                                        <Button
                                            variant="outlined"
                                            component="span"
                                            style={{
                                                backgroundColor: "#46474E",
                                                borderRadius: "2px",
                                                color: "#fff",
                                                width: "30%",
                                                border: "none",
                                                fontWeight: 700
                                            }}
                                        >
                                            {t("CONTENT.PUBLISH.ADD-IMAGE")}
                                        </Button>
                                    </label>
                                </div>
                            </Grid>

                            {
                                fileName && fileName.length > 0 &&
                                <div style={{ marginTop: '15px', width: '100%' }}>
                                    <div style={{ marginBottom: '15px' }}>Preview of uploaded images</div>
                                    <div className="preview-images">
                                        {
                                            fileName.map((item, index) =>
                                                <Grid key={index} item xs={3}>
                                                    <ImageThumb index={index} file={item} setFileName={setFileName} />
                                                </Grid>
                                            )
                                        }
                                    </div>

                                </div>
                            }

                        </>
                    }

                </Grid>
            </div>
        </DialogContent>

    );
};
const ImageThumb = ({ index, setFileName, file }) => {
    const deleteImg = (e) => {
        setFileName(oldArr => oldArr.filter((item, indx) => indx !== Number(index)))
    }

    return <div>
        <img
            width="30px"
            height="30px"
            className="publish-clear-image"
            src={file}
            alt="publish-icon" />
        <div className="publish-clear-icon" id={index}
            onClick={deleteImg}><DeleteIcon style={{ height: '20px', cursor: 'pointer' }} /></div>
    </div>;
};
export default StepSix;
